export default {
  reply: {
    en: 'Reply',
  },
  like: {
    en: 'Like',
  },
  dislike: {
    en: 'Dislike',
  },
}
